import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatNull } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';

import styles from '../../styles/DynamicModal.module.css';
import stylesSearch from '../../styles/Search.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const SearchUsers = ({ closeModal, preType, type }) => {
    const [users, setUsers] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    const inputRef = React.useRef(null);
    
    React.useEffect(() => {
        inputRef.current?.focus();
    }, []);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');
    const [role, setRole] = React.useState(type || preType || 'Арбитражный управляющий')

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500); // задержка 500 мс

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (debouncedSearchTerm.trim() == '') {
            setWarning('Введите поисковый запрос');
        } else {
            setLoading(true);

            axios.get(`/api/search-users?searchterm=${debouncedSearchTerm}&role=${role}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                if (response.data.length === 0) {
                    setUsers([]);
                    setWarning('Ничего не найдено');
                } else {
                    setUsers(response.data);
                    setWarning('');
                }
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }, [debouncedSearchTerm, role]);


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Поиск по пользователям</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main} style={{height: '80vh'}}>
                    <div className={stylesSearch.searchInputWrapper}>
                        <input type='text' value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='ФИО или адрес электронной почты...' ref={inputRef} />
                    </div>
                    <div className={stylesSearch.mainWrapper}>
                        {!preType &&
                        <div className='radioSwitchWrapper'>
                            <label className={`radioSwitchLabel ${role === 'Арбитражный управляющий' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='Арбитражный управляющий'
                                    checked={role === 'Арбитражный управляющий'}
                                    onChange={(e) => setRole(e.target.value)}
                                />
                                <span>Арбитражные управляющие</span>
                            </label>
                            <label className={`radioSwitchLabel ${role === 'АппаратСРО' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='АппаратСРО'
                                    checked={role === 'АппаратСРО'}
                                    onChange={(e) => setRole(e.target.value)}
                                />
                                <span>Аппарат СРО</span>
                            </label>
                            <label className={`radioSwitchLabel ${role === 'Все' ? 'selected' : ''}`}>
                                <input
                                    type='radio'
                                    name='typeSelector'
                                    value='Все'
                                    checked={role === 'Все'}
                                    onChange={(e) => setRole(e.target.value)}
                                />
                                <span>Все</span>
                            </label>
                        </div>}
                        <span style={{height: '20px'}}></span>
                        {loading ? <LoadingLines />
                        : warning ? <a className={`description ${stylesSearch.centerWarning}`}>{warning}</a>
                        : <>
                            <a className='description'>Первые 20 совпадений</a>
                            <div
                                className='tableRow nonActive' 
                                style={{gridTemplateColumns: '30fr 25fr 30fr 15fr'}} 
                            >
                                <div>
                                    ФИО
                                </div>
                                <div>
                                    Email
                                </div>
                                <div>
                                    Баланс
                                </div>
                                <div>
                                    Количество дел
                                </div>
                            </div>
                            {users.map(caseItem => (
                                <motion.div
                                    className='tableRow nonActive' 
                                    style={{gridTemplateColumns: '30fr 25fr 30fr 15fr'}} 
                                    key={caseItem.id}
                                    initial={{ scale: '97%', opacity: 0 }}
                                    animate={{ scale: '100%', opacity: 1 }}
                                    exit={{ scale: '97%', opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    layout
                                >
                                    <div>
                                        <Link
                                            className='aWithLink'
                                            to={`/account/${caseItem.id}`}
                                        >
                                            {caseItem.lastname} {caseItem.firstname} {caseItem.surname} 
                                        </Link>
                                        <span className='description'>{formatNull(caseItem.role)}</span>
                                        <p
                                            className='colorCell red'
                                        >
                                            {caseItem.approval=='Отключен' && 'Аккаунт деактивирован'}
                                        </p>
                                    </div>
                                    <div>{formatNull(caseItem.email)}</div>
                                    <div>
                                        {caseItem.role=='Арбитражный управляющий' ?
                                        <>
                                        <span
                                            className='horizontalContainer'
                                        >
                                            <a className={`${caseItem.balance<0 && 'colorCell red'}`}>{caseItem.balance + ' ₽'}</a>
                                            <p className='description'>Членские взносы</p>
                                        </span>
                                        <span className='horizontalLine'></span>
                                        <span
                                            className='horizontalContainer'
                                        >
                                            <a className={`${caseItem.special_balance<0 && 'colorCell red'}`}>{caseItem.special_balance + ' ₽'}</a>
                                            <p className='description'>Целевые взносы</p>
                                        </span>
                                        </>
                                        :
                                        <p className='description'>—</p>}
                                    </div>
                                    <div>
                                        {caseItem.role=='АппаратСРО' ? formatNull() : caseItem.count_user_cases}
                                    </div>
                                </motion.div>
                            ))}
                        </>
                        }
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default SearchUsers;
